/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from 'react'

import Box from '@mui/material/Box'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { useNavigate, useParams } from 'react-router-dom'

import {
	EMPEÑO_BY_ID,
	EMPEÑO_PAGO_DETALLES,
	PRODUCTOS_DETAILS_BY_SKU,
} from '../../../../Constants/ApiConstants'
import requests from '../../../AxiosCalls/AxiosCall'
import '../../../../Styles/PayCodi.css'
import NumberFormat from 'react-number-format'
import AmountPayPrimerPagoRenta from './PaymentComponentPrimerPagoRenta/AmountPayPrimerPagoRenta'
import CardPayPrimerPagoRenta from './PaymentComponentPrimerPagoRenta/CardPayPrimerPagoRenta'
import PayPrimerPagoRenta from './PaymentComponentPrimerPagoRenta/PayPrimerPagoRenta'

const PaymentFlowPrimerPagoRenta = (props) => {
	const { id } = useParams()

	const [activeStep, setActiveStep] = useState(0)
	const [skipped, setSkipped] = useState(new Set())
	let navigate = useNavigate()
	const sku = JSON.parse(sessionStorage.getItem('sku'))
	const [_Producto, setProducto] = useState([])

	const isStepOptional = (step) => {
		return step === 1
	}

	const isStepSkipped = (step) => {
		return skipped.has(step)
	}

	const handleNext = () => {
		let newSkipped = skipped
		if (isStepSkipped(activeStep)) {
			newSkipped = new Set(newSkipped.values())
			newSkipped.delete(activeStep)
		}

		setActiveStep((prevActiveStep) => prevActiveStep + 1)
		setSkipped(newSkipped)
	}

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1)
	}

	const handleReset = () => {
		setActiveStep(0)
	}
	const getRegistro = () => {
		props.setOpenLoadingScreen()
		requests
			.get(PRODUCTOS_DETAILS_BY_SKU, sku)
			.then((response) => {
                console.log(response)
				setProducto(response)

				props.setCloseLoadingScreen()
			})
			.catch((error) => {
				console.log(error)
				props.setCloseLoadingScreen()
			})
	}

	useEffect(() => {
		getRegistro()
	}, [])

	//::::::::::::::::::::: Titulos de cada paso ::::::::::::::::::::::::::
	const steps = [
		'Monto a pagar',
		'Pagar mediante CODI',
		'Resumen de pago',
	]
	//::::::::::::::::::::: Vistas de cada paso ::::::::::::::::::::::::::
	function getSteps(step, handleNext, handleBack) {
		switch (step) {
			case 0:
				return (
					<AmountPayPrimerPagoRenta
						handleNext={handleNext}
						handleBack={handleBack}
						data={_Producto}
					/>
				)
			case 1:
				return (
					<PayPrimerPagoRenta
						handleNext={handleNext}
						handleBack={handleBack}
						data={_Producto}
					/>
				)
			case 2:
				return (
					<div>hola</div>
					// <SuccessfullLiq
					// 	handleNext={handleNext}
					// 	handleBack={handleBack}
					// 	data={_Empeño}
					// 	detalles={_Detalles}
					// />
				)
			default:
				throw new Error('Unknown step')
		}
	}

	//::::::::::::::::::::: Vistas de cada paso ::::::::::::::::::::::::::
	return (
		<div className='containerViewUser'>
			<div className='w60'>
				<div>
					<div className='box-proceso-producto-pay'>
						<div className='w20 p2'>
							<img className='img-proceso-producto' src={_Producto.txtUrl} />
						</div>
						<div className='flex-column-start w80 line-height-0'>
							<div>
								<div>
									<p className='title-proceso-producto'>
										{_Producto.txtProductoH === null ? _Producto.txtProductoM : _Producto.txtProductoH} - {_Producto.intIdMarca} 
									</p>
                                    <div className='flex-start'>
										<p>
											<strong>Precio Total del Artículo: </strong>
											<NumberFormat
												value={_Producto.dblPrecioFinal}
												displayType={'text'}
												fixedDecimalScale={true}
												decimalScale={2}
												thousandSeparator={true}
												prefix={'$ '}
												suffix={' MXN'}
											/>
										</p>
										&nbsp; &bull; &nbsp;
										<p>
											<strong>Réntalo por: </strong>
											<NumberFormat
												value={(_Producto.dblPrecioFinal * 15) / 100}
												displayType={'text'}
												fixedDecimalScale={true}
												decimalScale={2}
												thousandSeparator={true}
												prefix={'$ '}
												suffix={' MXN'}
											/>
										</p>
									</div>
                                    <div className='flex-start'>
                                        <p>
											<strong>SKU: </strong> {_Producto.txtSkuReg}											
										</p>                                                                             
                                    </div>
                                    <div className='flex-start'>
                                        <p>
											<strong>Material: </strong> {_Producto.intIdMaterial}										
										</p>                                                                              
                                    </div>
                                    <div className='flex-start'>
                                        <p>
											<strong>Color: </strong> {_Producto.intIdColor}										
										</p>                                                                              
                                    </div>
                                    <div className='flex-start'>
                                        <p>
											<strong>Talla/Tamaño: </strong> {_Producto.intIdTallaTamano}											
										</p>                                                                                
                                    </div>									
								</div>

								{/* <p className=''>
									<strong>Saldo Actual:</strong> $ 45,900 MXN
								</p> */}
							</div>
						</div>
					</div>
				</div>

				<Box sx={{ width: '100%', mt: 3 }}>
					<Stepper activeStep={activeStep}>
						{steps.map((label, index) => {
							const stepProps = {}
							const labelProps = {}

							if (isStepSkipped(index)) {
								stepProps.completed = false
							}
							return (
								<Step key={label} {...stepProps}>
									<StepLabel {...labelProps}>{label}</StepLabel>
								</Step>
							)
						})}
					</Stepper>
					{activeStep === steps.length ? (
						<div className='box-paycodi-stepper'>
							<Typography sx={{ mt: 2, mb: 1 }}>
								All steps completed - you&apos;re finished
							</Typography>
							<Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
								<Box sx={{ flex: '1 1 auto' }} />
								<Button onClick={handleReset}>Ver historia de pago</Button>
							</Box>
						</div>
					) : (
						<div className='box-paycodi-stepper'>
							{getSteps(activeStep, handleNext, handleBack, navigate)}

							{/* <div className='body-stepper'>Step {activeStep + 1}</div>
							<div className='footer-stepper'>
								<Button
									className='btn-stepper'
									disabled={activeStep === 0}
									onClick={handleBack}
								>
									Regresar
								</Button>
								<Button className='btn-stepper' onClick={handleNext}>
									{activeStep === steps.length - 1 ? 'Finalizar' : 'Continuar'}
								</Button>
							</div> */}
						</div>
					)}
				</Box>
			</div>
		</div>
	)
}

export default PaymentFlowPrimerPagoRenta